import Expand from "elements/ExpandButton";

export default function ReadMoreCard({
	title,
	body = "",
	onClick,
}: {
	title: string;
	body?: string;
	onClick?: () => void;
}) {
	const hasEmElement = (value: string) => {
		return value.includes("<em>");
	};

	return (
		<div className="help-center-articles-cards" onClick={onClick}>
			<p className="lg help-center-articles-card-title">{title}</p>
			{hasEmElement(body) ? (
				<p
					className="help-center-articles-card-body"
					dangerouslySetInnerHTML={{ __html: body }}
				/>
			) : (
				<p className="help-center-articles-card-body">{body}</p>
			)}

			<Expand defaultActive={false} noSwitch>
				Read More
			</Expand>
		</div>
	);
}
